import React from "react";
import { Container } from "react-bootstrap";
import "./AboutBanner.css";
import FontSpirulina from '../../font_component/spirulina_font/FontSpirulina';
import BannerTitle from './../../font_component/banner_title/BannerTitle';

const AboutBanner = () => {
  return (
    <div className="about-banner">
      <Container className="text-center text-white">

        <BannerTitle
          firstText="Where Wellness Meets "
          highlightText="Opportunity"
        />

      </Container>
    </div>
  );
};

export default AboutBanner;
